import React from 'react';
import { withNamespaces } from 'react-i18next';
import { Link } from 'react-router-dom';
import PortalImg from '../../assets/img/portal.svg';
import { HTTPCodes } from '../../utils/Constants';
import { Routes as configRouter } from '../../config/Routes';

const NotFound = (props) => {
  const { t } = props;
  return (
    <div className="not-found">
      <h1 className="not-found-code">{HTTPCodes.NOT_FOUND}</h1>
      <div className="not-found-portal">
        <img src={PortalImg} alt="" className="not-found-image" />
        <div className="circle-1" />
        <div className="circle-2" />
        <div className="circle-3" />
        <div className="circle-4" />
        <div className="circle-5" />
      </div>
      <h2 className="epic-text not-found-title">{t('notFoundTitle')}</h2>
      <p className="not-found-subtitle">{t('notFoundSubtitle')}</p>
      <div className="not-found-buttons">
        <Link to={configRouter.HOME} className="btn btn-dark text-uppercase">
          { t('buttonGoHome') }
        </Link>
      </div>
    </div>
  );
};

export default withNamespaces()(NotFound);
